import { AnimatePresence, motion } from "framer-motion";
import { Info, X } from "lucide-react";

export const HsaCallout = ({ open, onClose }) => {
  const goToSection = () => {
    onClose();
    document.getElementById("hsa-fsa")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.aside
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          data-testid="hsa-callout"
          role="dialog"
          aria-label="Did you know? HSA and FSA information"
          className="fixed z-50 left-4 right-4 bottom-24 sm:left-6 sm:right-auto sm:bottom-6 sm:max-w-sm bg-white border border-[var(--brand-gold-soft)] border-l-4 border-l-[var(--brand-gold)] shadow-xl"
        >
          <button
            type="button"
            data-testid="hsa-callout-close"
            onClick={onClose}
            aria-label="Dismiss"
            className="absolute right-2.5 top-2.5 p-1 text-[var(--brand-muted)] transition-colors hover:text-[var(--brand-navy)]"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </button>
          <div className="flex gap-3.5 p-5 pr-9">
            <span
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--brand-cream)] text-[var(--brand-gold)]"
              aria-hidden="true"
            >
              <Info className="h-5 w-5" />
            </span>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--brand-gold)]">
                Did you know?
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-[var(--brand-navy-deep)]">
                Your HSA or FSA may help pay for your visit &mdash; eligible medical expenses can
                include a consultation to evaluate perimenopause or menopause symptoms.
              </p>
              <button
                type="button"
                data-testid="hsa-callout-learn"
                onClick={goToSection}
                className="mt-3 text-sm font-semibold text-[var(--brand-navy)] underline decoration-[var(--brand-gold)] underline-offset-4 transition-colors hover:text-[var(--brand-gold)]"
              >
                See how it works
              </button>
            </div>
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  );
};
